'use client';

import React from 'react';
import Image from 'next/image';
import { TickerDirection } from './TickerDirection';
import { TickerPercentage } from './TickerPercentage';
import styled from '@benzinga/themetron';
import { getTextColor } from './utils';

export type TickerVariant = 'box' | 'light' | 'ticker' | 'article';

export interface WrapperProps {
  $value?: number;
  $variant?: string;
}
export interface TickerDetailsProps {
  direction?: boolean;
  hideChange?: boolean;
  logo?: string;
  symbol: string;
  value?: number;
  variant?: TickerVariant;
}

export const TickerDetails: React.FC<TickerDetailsProps> = ({
  direction,
  hideChange,
  logo,
  symbol,
  value,
  variant,
}) => {
  const isArticleVariant = variant === 'article';

  return (
    <>
      {!isArticleVariant && direction && !!value && (
        <span className="mr-1">
          {value >= 0 ? <TickerDirection direction="up" /> : <TickerDirection direction="down" />}
        </span>
      )}
      {logo && logo.length && (
        <div className="-ml-px -mt-px -mb-px flex items-center justify-center w-6">
          <Image alt={symbol} height={50} src={logo} width={50} />
        </div>
      )}
      <TickerBoxSymbol $value={value} $variant={variant}>
        {isArticleVariant ? `(${symbol})` : symbol}
      </TickerBoxSymbol>
      {!isArticleVariant && !!value && !hideChange && <TickerPercentage value={value} />}
    </>
  );
};

export const TickerBoxSymbol = styled.span<WrapperProps>`
  color: ${({ $value, $variant, theme }) => getTextColor({ theme, value: $value, variant: $variant })} !important;
  font-size: ${({ theme }) => (theme.fontSize ? theme.fontSize.base : '14px')};
  font-weight: bold;
`;
